import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { ConceptReturnRisk } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: ConceptReturnRisk & { riskProfil: any }) {
    let options: AbstractControlOptions = {};
    const q20FormConfig: FormConfig<ConceptReturnRisk & { riskProfil: any }> = {
      ownerId: [entity.ownerId],
      userFirstName: [entity.userFirstName],
      userLastName: [entity.userLastName],
      // conceptReturnRisk: [
      //   entity?.conceptReturnRisk || null,
      //   Validators.required,
      // ],
      riskProfil: this.formBuilder.group({
        moneyGames: [
          entity?.riskProfil?.moneyGames || null,
          Validators.required,
        ],
      }),
    };

    return this.formBuilder.group(q20FormConfig, options);
  }
  generate(entity: ConceptReturnRisk[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
